module.exports = __webpack_public_path__ + "static/app-account-preview-5cf9909b8b993a001dbe834604a25e0c.webp";